// All JavaScript in here will be loaded client-side

// Expose components globally so ReactJS.NET can use them
import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { logger, crashReporter } from './middleware/general-middleware';
import ErrorBoundry from './components/ErrorBoundry';
import blogArticleReduceres from './reducers/blog-article-reducers';
import Components from './components';
import BlogArticlesContainer from './components/blog-articles/BlogArticlesContainer';
import PressReleasesContainer from './components/press-releases/PressReleasesContainer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; /* eslint-disable-line no-underscore-dangle */

if (document.getElementById('blog-article-root')) {
  const blogArticleStore = createStore(
    blogArticleReduceres, {
      initialState: {
        articleItems: window.ArticleData.articleItems,
      },
      filters: window.ArticleData.articleFilters,
      articleItems: window.ArticleData.articleItems,
      noResultsMessage: window.ArticleData.noResultsMessage,
      articlesListLinkText: window.ArticleData.articlesListLinkText,
      selectedFilters: {
        categoryFilter: [],
      },
      filterToggle: false,
    },
    composeEnhancers(applyMiddleware(logger, crashReporter)),
  );

  ReactDom.render(
    React.createElement(ErrorBoundry, null, React.createElement(Provider, {
      store: blogArticleStore,
    }, React.createElement(BlogArticlesContainer))),
    document.getElementById('blog-article-root'),
  );
}

if (document.getElementById('press-release-root')) {
  const pressReleaseStore = createStore(
    blogArticleReduceres, {
      initialState: {
        articleItems: window.ArticleData.articleItems,
      },
      filters: window.ArticleData.articleFilters,
      articleItems: window.ArticleData.articleItems,
      noResultsMessage: window.ArticleData.noResultsMessage,
      articlesListLinkText: window.ArticleData.articlesListLinkText,
      selectedFilters: {
        categoryFilter: [],
      },
      filterToggle: false,
    },
    composeEnhancers(applyMiddleware(logger, crashReporter)),
  );

  ReactDom.render(
    React.createElement(ErrorBoundry, null, React.createElement(Provider, {
      store: pressReleaseStore,
    }, React.createElement(PressReleasesContainer))),
    document.getElementById('press-release-root'),
  );
}

export default Components;
